<template>
  <a-popover>
    <template #content>
      <color-picker  v-model:color="color" :format="format" @change="colorChange"></color-picker>
    </template>
    <div style="width:24px;height:24px;border-radius: 5px;border:1px solid #efefef" :style="{background:color}"></div>
  </a-popover>
</template>
<script setup lang="ts">
import ColorPicker from './index.vue'
import {defineProps,defineEmits,ref,watch}  from 'vue'
import {Color} from './color'
const color=ref<Object>(null)
const props=defineProps({
  value:{
    type: [String, Object] as PropType<ColorInput>,
    default: "#000000"
  },
  format:{type:String,default:'hex'}
})
const colorClass = new Color();
const emits=defineEmits(['update:value','change'])
const colorChange=(e)=>{

  emits('update:value',color.value)
  emits('change',color.value)
}
watch(()=>props.value,(n,o)=>{
  if(n){
     color.value=n
  }
},{immediate:true})
</script>
